import React from "react";
import classnames from "classnames";
import { useGlobal } from "reactn";
import { Item } from "@outplayed/tooltips";
import { getRiotAssetsContext } from "@outplayed/riot-assets";
import { SummonerSpell } from "@outplayed/tooltips";
import { MediaQuery } from "@outplayed/responsive";

const ChampionSpells = (props) => {
  const { useRiotMythicItems, useRiotCompletedItems } = getRiotAssetsContext();
  const { championName, data } = props;
  const [webpSupport] = useGlobal("webpSupport");
  const { data: mythicItems, loading: loadingMythicItems, error: errorMythicItems } = useRiotMythicItems({ ssr: true });
  const {
    data: completedItems,
    loading: loadingCompletedItems,
    error: errorCompletedItems,
  } = useRiotCompletedItems({ ssr: true });

  if (!data || (data && data.length === 0)) {
    return (
      <div className="champion-spells">
        <div className="side-column_title">Summoner Spells</div>
      </div>
    );
  }
  const spells = [4, 12, 4];
  return (
    <div className="champion-spells">
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
        <div className="side-column_title">Summoners</div>
      </MediaQuery>
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        <div className="side-column_title">Summoner Spells</div>
      </MediaQuery>
      <div className="side-column_grid-item top-items">
        {data &&
          data.slice(0, 3).map(({ itemId, pickRate }, index) => (
            <div
              key={data[index]["spell"]}
              className={classnames("item", {
                "do-nt-display": mythicItems && mythicItems.includes(itemId),
              })}
            >
              <div className="item-image">
                <SummonerSpell spellId={data[index]["spell"]} ssr webp={webpSupport} />
              </div>
              <div className="pick-rate">{Math.round(data[index]["percentage"])}%</div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ChampionSpells;
